'use client'
import dynamic from 'next/dynamic'

// this component is necessary to completely block our SSR for the application, since we have libraries that are incompatible with SSR
export const NoSSROriginationApp = dynamic(() => import('@/OriginationApp').then(mod => mod.OriginationApp), {
  ssr: false
})
